export default "__VITE_ASSET__DuSFYxpd__"